<template>
  <Vcode :show="isShow"
         slider-text="Drag Slider to Complete Puzzle"
         fail-text="Verification Failed, Please Try Again"
         success-text="Verification Passed"
         :range="5"
         @success="onSubmitLogin"
         @close="close"
  />
  <van-toast v-model:show="disabled" type="loading" overlay="true" duration="0"
             forbid_click="true" message="Loading..."></van-toast>
  <van-nav-bar
      title="密码登录"
      left-text="返回"
      left-arrow
      fixed
      @click-left="this.$router.push('/inbox');"
  />
  <div style="margin-top: 7vh">
    <center>
      <div style="width: 96px; height: 96px; margin: 0 auto 18px; border: 2px solid #1989fa; border-radius: 50%; color: #1989fa; display: flex; align-items: center; justify-content: center; font-size: 30px; font-weight: 700;">CF</div>
      <h2 style="margin-bottom: -15px">CourtFlow</h2>
      <h4>学员训练管理</h4>
      <h3>密码登录</h3>
    </center>
    <center>
      <div :style="{maxWidth: '400px', marginTop: '15px'}">
        <van-form @submit="onLogin">
        <van-cell-group inset>
          <van-field
              v-model="username"
              required
              left-icon="user"
              placeholder="用户名"
              :rules="[{ required: true, message: '请输入用户名' }]"
          />
          <van-field
              v-model="password"
              type="password"
              required
              left-icon="lock"
              placeholder="密码"
              :rules="[{ required: true, message: '请输入密码' }]"
          />
        </van-cell-group>
          <br/>
          <van-button round block icon="certificate" :disabled="disabled" type="primary" native-type="submit" style="width: 80%; max-width: 320px">登录</van-button>
        </van-form>
      </div>
      <p style="font-size: 9pt; margin-top: 11pt">
        忘记用户名或密码？<br>可
        <router-link to="/findAccount" style="font-size: 9.5pt" >查询用户名</router-link>或
        <router-link to="/resetPassword" style="font-size: 9.5pt" >重置密码</router-link>
      </p>
    </center>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import {showToast, showSuccessToast, showFailToast, showDialog  } from "vant";


export default {
  created(){
    const token = Cookies.get('token');
    if(token != null){
      this.$http.post('/user/verify?token='+ Cookies.get('token'))
          .then(response =>{
            if(response.data.status === 3)
              this.$router.push('/staff');
            else if(response.data.status > 0 && response.data.status < 3)
              this.$router.push('/main');
          }).
      catch(error =>{
      });
    }
  },
  data() {
    return {
      username: '',
      password: '',
      isShow: false,
      disabled: false,
      loading: false
    };
  },
  methods: {
    onLogin() {
      this.isShow = true;
    },
    onSubmitLogin(){
      this.isShow = false;
      this.disabled = true;
      this.$http({
        method: 'POST',
        url: `/user/login?username=${encodeURIComponent(this.username)}&password=${encodeURIComponent(this.password)}`,
      }).then((response) => {
        this.disabled = false;
        if(response.data.status === -2){
          showFailToast('用户名 or 密码 Invalid');
          return;
        }
        if(response.data.status === -1){
          showFailToast('The current account is still pending.');
          return;
        }
        if(response.data.status === 0){
          showFailToast('Current account has been blocked, please contact customer service.');
          return;
        }
        if(response.data.status > 3){
          showToast('The current account is an administrator account, please go to the backstage.');
          return;
        }
        Cookies.set('token', response.data.data);
        if(response.data.status === 3)
          this.$router.push('/staff');
        else
          this.$router.push('/main');
        if(response.data.status === 1){
          showDialog({
            title: 'Account Restrictions',
            message: 'Hello, we are very sorry to inform you that due to your repeated participation but absence, you are temporarily unable to participate in our activities directly or by alternate, and no designated account transfer, and are only allowed to participate through designated account transfer. Please contact our customer service for a solution!',
            confirmButtonText: 'I Understand'
          }).then(() => {
            // on close
          });
        }else{
          showSuccessToast('Login Successfully');
        }
      }).catch((error) => {
            console.log(error);
            showFailToast('Internet Error');
        this.disabled = false;
          }
      );
    },
    close(){
      this.isShow = false;
    }
  }
};
</script>
